import React from 'react';
import { Route, Switch, useParams } from 'react-router';
import ChatPage from 'components/container/ConnectedChatPage';
import ViewChatPage from 'components/container/ConnectedViewChatPage';
import LoadChat from 'components/container/LoadChat';
import * as API from 'generated/api';
import * as FFObject from 'model/FFObject';

interface Props {
  login: (username: string, password: string) => void;
  accessToken: string | null;
}

function Routes(_props: Props) {
  return (
    <Switch>
      {/* Routes without login screen */}
      <Route path="/embed/:chat">
        <URLParamsConnectedChatLoader urlParamKey="chat">
          {({chat, objects}) => (
            <ChatPage
              chat={chat}
              objects={objects}
              embeddable={true}
            />
          )}
        </URLParamsConnectedChatLoader>
      </Route>

      <Route path="/view/:chat">
        <URLParamsConnectedChatLoader urlParamKey="chat">
          {({chat, objects, chatKey}) => (
            <ViewChatPage
              chat={chat}
              objects={objects}
              chatKey={chatKey}
            />
          )}
        </URLParamsConnectedChatLoader>
      </Route>

      {process.env.REACT_APP_WEBSITE_HOST && (
        <Redirect url={process.env.REACT_APP_WEBSITE_HOST} />
      )}

    </Switch>
  );
}

interface Redirect$Props {
  url: string | ((data: {queryParams: {}}) => string);
  children: JSX.Element;
}

const Redirect = function({ url, children }: Redirect$Props) {
  React.useEffect(() => {
    const evaluatedURL = typeof(url) === 'function'
      ? url({ queryParams: new URLSearchParams(window.location.search) })
      : url

    window.location.replace(evaluatedURL)
  })

  return children;
};

Redirect.defaultProps = {
  children: <></>
};

interface URLParamsConnectedChatLoader$Props {
  urlParamKey: string;
  children: (loaded: { chat: API.FFPublicChat, objects: Record<string, FFObject.FFObject>, chatKey: string }) => JSX.Element;
}

function URLParamsConnectedChatLoader({ urlParamKey, children }: URLParamsConnectedChatLoader$Props) {
  const chatKey = (useParams() as any)[urlParamKey] as string;
  return (
    <LoadChat chatKey={chatKey}>
      {([chat, objects]) => (
        children({ chat, objects, chatKey })
      )}
    </LoadChat>
  );
}

export default Routes;
